module.exports = new __parcel__URL__("keyboard-wireless.a8cb888a.svg").toString();